import { Link } from 'react-router-dom'
import { MAX_YEAR, THEMATA_YEAR } from './constants.js'

function Footer() {
  return (
    <footer className="border-t mt-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 py-10 grid grid-cols-1 sm:grid-cols-3 gap-8 text-sm text-gray-600">

        {/* Brand */}
        <div>
          <div className="text-lg font-semibold text-gray-900">
            Panellhnies<sup>+</sup>
          </div>
          <p className="mt-2 text-gray-500">
            Όλα όσα χρειάζεσαι για τις Πανελλήνιες.<br />
            Βάσεις, μόρια & παλιά θέματα.
          </p>
        </div>

        {/* Navigation */}
        <div>
          <p className="font-medium text-gray-900 mb-3">Πλοήγηση</p>
          <ul className="space-y-2">
            <li>
              <Link to={`/vaseis/${MAX_YEAR}?ordering=-score`} className="hover:text-gray-900 cursor-pointer">
                Βάσεις Σχολών
              </Link>
            </li>
            <li>
              <Link to={`/themata/${THEMATA_YEAR}`} className="hover:text-gray-900 cursor-pointer">
                Παλιά Θέματα
              </Link>
            </li>
            <li>
              <Link to="/ypologismos-morion" className="hover:text-gray-900 cursor-pointer">
                Υπολογισμός Μορίων
              </Link>
            </li>
            <li>
              <Link to="/stoxoi-sxolon" className="hover:text-gray-900 cursor-pointer">
                Στόχοι Σχολών
              </Link>
            </li>
            <li>
              <Link to="/about" className="hover:text-gray-900 cursor-pointer">
                Σχετικά με εμάς
              </Link>
            </li>
          </ul>
        </div>

        {/* Legal */}
        <div>
          <p className="font-medium text-gray-900 mb-3">Νομικά</p>
          <ul className="space-y-2">
            <li>
              <Link to="/privacy" className="hover:text-gray-900 cursor-pointer">
                Πολιτική Απορρήτου
              </Link>
            </li>
            <li>
              <Link to="/terms" className="hover:text-gray-900 cursor-pointer">
                Όροι Χρήσης
              </Link>
            </li>
            <li>
              <Link to="/cookies" className="hover:text-gray-900 cursor-pointer">
                Cookies
              </Link>
            </li>
          </ul>
        </div>
      </div>

    </footer>
  )
}

export default Footer
